import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { connect } from "react-redux";
import { Form, Button, Modal } from "react-bootstrap";
import CircularProgress from '@material-ui/core/CircularProgress';
import { injectIntl } from "react-intl";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import { editForumAnswer } from '../../../crud/qa.crud';
import * as qa from "../../../store/ducks/qa.duck";
const EditForumAnswer = (props) => {
    const [loading,
        setLoading] = useState(false);
    const [description,
        setDescription] = useState(props.forumAnswer.answer);
    const [errors,
        setErrors] = useState({ description: null });
    const { classes, forumAnswer, qaId } = props;

    useEffect(() => {
        const dataProps = JSON.parse(JSON.stringify(forumAnswer));
        setDescription(dataProps.answer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDescriptionChangeHandler = (event) => {
        setDescription(event.target.value);
        if (!event.target.value) {
            setErrors({
                ...errors,
                description: 'Description is required'
            });
        } else {
            setErrors({
                ...errors,
                description: null
            });
        }
    }

    const resetState = () => {
        setDescription('');
        setErrors({

            description: null
        });
    }


    const validForm = () => {
        let e = true;

        if (!description) {
            setErrors({
                ...errors,
                description: 'Description is required'
            });
            e = false;
        } else {
            setErrors({
                ...errors,
                description: null
            });
        }
        return e;
    };


    const handleSubmit = () => {
        if (validForm()) {
            setLoading(true);

            const payload = {
                answer: description
            };

            editForumAnswer(qaId, forumAnswer._id, payload).then((output) => {
                if (output.data.success) {
                    props.qaAnswerUpdated();
                    resetState();
                    setLoading(false);
                    toast.success('Forum answer is successfully updated!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
                    props.handleClose();
                }
            }).catch((error) => {
                console.log('error', error);
                setLoading(false);

            });
        }

    };

    return (
        <React.Fragment>
            <Modal show={props.show} onHide={() => props.handleClose()}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Answer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="answerForm.description">
                            <Form.Control as="textarea"
                                rows="3" value={description} onChange={onDescriptionChangeHandler} isInvalid={!!errors.description} />
                            <Form.Control.Feedback type="invalid">
                                {errors.description}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => props.handleClose()}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        style={{
                            position: "relative"
                        }}
                        onClick={() => handleSubmit()}
                        disabled={loading}>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
};

const mapStateToProps = state => {
    return { data: state };
};

const mapDispatchToProps = dispatch => {
    return {
        qaAnswerUpdated: () => dispatch(qa.actions.qaAnswerUpdated())
    };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles((theme) => ({
    ...styles(theme)
}), { withTheme: true })(EditForumAnswer)));
